// src/ui/steps/step3-festival-werkdagen.jsx — Festival ZZP-flow stap 3
// Werkdagen-invoer (één veld). Eén werkdag = 7,6 uur (excl. pauze, conform
// SAV) — we tonen de omrekening naar uren in de lopend-totaal-AsideCard
// zodat de zzp'er ziet hoeveel uur er onder de werkdagen zit. Prijzen worden
// hier nog NIET getoond — die volgen in stap 5. Festivaldag-toeslag,
// nachtwerk, lunch/diner en reisuren komen als generieke onderhandelpunten
// in stap 5 terug.
import React from "react";
import {
  FW, FwButton, FwInput,
  StepHeader, NiveauBadge, AsideCard,
} from "../primitives";

const UREN_PER_WERKDAG = 7.6;

export const StepFestivalWerkdagen = ({ state, setState, next, back }) => {
  const huidigeRol = state.rollen?.[0];

  const [totaal, setTotaal] = React.useState(huidigeRol?.werkdagen?.totaal ?? "");

  React.useEffect(() => {
    if (!huidigeRol) back();
  }, []);

  React.useEffect(() => {
    setState(s => ({
      ...s,
      rollen: (s.rollen || []).map((r, i) => i === 0 ? {
        ...r,
        werkdagen: {
          totaal: Number(totaal) || 0,
          festivaldagen: 0,
        },
      } : r),
    }));
  }, [totaal]);

  if (!huidigeRol) return null;

  const totaalNum = Number(totaal) || 0;
  const urenTotaal = totaalNum * UREN_PER_WERKDAG;
  const valid = totaalNum > 0;

  const setTotaalSafe = (raw) => {
    if (raw === "") return setTotaal("");
    const n = Math.max(0, Math.min(500, Number(raw) || 0));
    setTotaal(n);
  };

  const fmtUren = (u) => {
    if (Number.isInteger(u)) return `${u} uur`;
    return `${u.toFixed(1).replace(".", ",")} uur`;
  };

  return (
    <div>
      <StepHeader
        tag="Werkdagen"
        title="Hoeveel werkdagen besteed je aan deze opdracht?"
        sub="Bij filmfestivals rekenen we in werkdagen — voorbereiding, festival én afronding samen. Eén werkdag = 7,6 uur (excl. pauze, conform de Standaard Basisregeling SAV)."
        onBack={back}
      />

      <div className="role-summary" style={{
        display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap",
        padding: "14px 18px", marginBottom: 20,
        background: FW.cream, border: `1.5px solid ${FW.gray100}`, borderRadius: 14,
      }}>
        <div style={{ fontSize: 14, color: FW.gray500, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>Je rol</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: FW.navy }}>{huidigeRol.rol}</div>
        <div style={{ fontSize: 14, color: FW.navy2 }}>· {huidigeRol.dep}</div>
        <NiveauBadge niveau={huidigeRol.niveau} />
      </div>

      <div className="row-2col" style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 24, alignItems: "start" }}>
        <div>
          <div style={{
            padding: 24, background: FW.white,
            border: `1.5px solid ${FW.gray100}`, borderRadius: 18,
          }}>
            <FwInput
              label="Totaal werkdagen"
              type="number"
              min="0"
              value={totaal}
              onChange={e => setTotaalSafe(e.target.value)}
              suffix="dagen"
              hint="Alle dagen die je aan deze opdracht besteedt — voorbereiding, festival én afronding samen."
            />
          </div>
        </div>

        <AsideCard>
          <div style={{ fontSize: 14, fontWeight: 700, color: FW.navy, marginBottom: 10, display: "inline-flex", alignItems: "center", gap: 6 }}>
            <i className="ri-calculator-line" /> Lopend totaal
          </div>
          <div style={{ display: "grid", gap: 6, fontSize: 14, color: FW.navy2 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>Werkdagen</span>
              <span style={{ fontWeight: 700, color: FW.navy }}>{totaalNum} {totaalNum === 1 ? "dag" : "dagen"}</span>
            </div>
          </div>
          <div style={{ height: 1, background: FW.gray100, margin: "12px 0" }} />
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15 }}>
            <span style={{ color: FW.navy2 }}>Omgerekend</span>
            <span style={{ fontWeight: 700, color: FW.navy }}>{fmtUren(urenTotaal)}</span>
          </div>
          <div style={{ fontSize: 12, color: FW.gray500, marginTop: 8, lineHeight: 1.4 }}>
            {totaalNum > 0
              ? `${totaalNum} werkdag${totaalNum === 1 ? "" : "en"} × 7,6 uur (SAV-norm, excl. pauze).`
              : "Eén werkdag wordt gerekend als 7,6 uur (excl. pauze, conform SAV)."}
          </div>
        </AsideCard>
      </div>

      <div className="step-nav" style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
        <FwButton variant="ghost" arrow={false} onClick={back}>← Terug</FwButton>
        <FwButton variant="primary" onClick={next} disabled={!valid}>
          Bekijk je openingsbod
        </FwButton>
      </div>
    </div>
  );
};
